import { USER_API_CONFIG } from '@/project/configs/api.js'

const { baseURL, serviceName, serviceGroup } = USER_API_CONFIG

export class UserSerializer {
  get type() {
    return 'user'
  }

  static get endpoints() {
    return {
      GET: (payload) => {
        const userId = payload?.userId || window.localStorage.getItem('user:userId') || ''
        return `${baseURL}/${serviceName}/${userId}?group=${serviceGroup}`
      },
      POST: ({ action }) => {
        if (action === 'login') return `${baseURL}/${serviceName}/login?group=${serviceGroup}`
        if (action === 'register') return `${baseURL}/${serviceName}/register?group=${serviceGroup}`
        if (action === 'update') return `${baseURL}/${serviceName}/update?group=${serviceGroup}`
        return `${baseURL}/${serviceName}/login?group=${serviceGroup}`
      },
      PUT: () => ``,
      PATCH: () => ``,
      DELETE: () => ``,
    }
  }

  serialize(data) {
    if (data.action === 'login') {
      return {
        email: data.email,
        password: data.password,
      }
    }
    if (data.action === 'register') {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        email: `${data.email}`.toLowerCase(),
        password: data.password,
        countryCode: data.countryCode || 'BJ',
        metadata: data.metadata || {},
      }
    }
    return data
  }

  deserialize(raw, payload, method) {
    const statusCode = raw.statusCode
    const userData = raw.data ? { ...raw.data } : null

    if (userData) {
      // Extraction du rôle et des permissions (depuis la racine ou via metadata)
      userData.role = userData.role || userData.metadata?.role || 'admin' // default to admin for testing, or '' ? Let's use metadata or fallback
      userData.permissions = userData.permissions || userData.metadata?.permissions || []
    }

    if (method === 'POST') {
      if (statusCode === 200 || statusCode === 201) {
        if (userData && userData.id) {
          window.localStorage.setItem('user:userId', userData.id);
        }

        return { 
          statusCode, 
          message: raw.message || 'Success', 
          user: userData
        }
      }
      return { 
        statusCode: statusCode || 400, 
        message: raw.message || 'Bad response from server', 
        user: {} 
      }
    }

    if (method === 'GET') {
      if (statusCode === 200) {
        return { statusCode: 200, message: raw.message || 'Success', user: userData }
      }
      return { 
        statusCode: statusCode || 400, 
        message: raw.message || 'Bad response from server', 
        user: {} 
      }
    }

    // Default error handling for unknown methods
    return {
      statusCode: statusCode || 500,
      message: raw.message || 'Unknown error',
      user: {}
    }
  }
}
